import { ChangeEvent } from "react";
import {
  ActionMeta,
  MultiValue,
  OptionsOrGroups,
  SingleValue,
} from "react-select";
import AsyncSelect from "react-select/async";
import Select from "react-select/dist/declarations/src/Select";

import styles from "../CustomSelect.module.scss";
import "./customSearchDropdown.css";

interface ICustomSearchDropdown {
  label?: string;
  // onChange: (
  //   newValue: MultiValue<string> | SingleValue<string>,
  //   actionMeta: ActionMeta<string>
  // ) => void;
  onChange: any;
  iconType?: string;
  loadOptions: (arg: string) => Promise<any>;
  register?: React.Ref<Select<string, boolean, any>> | undefined;
  name?: string;
  isShowLabel?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  defaultOptions?: boolean | OptionsOrGroups<string, any> | undefined;
  labelClass?: string;
  defaultValue?: null | undefined | string;
  disabled?: boolean;
  placeholder?: string;
}
const CustomSearchDropDown = ({
  label,
  onChange,
  iconType,
  loadOptions,
  register,
  name,
  isShowLabel,
  isMulti,
  isSearchable,
  defaultOptions,
  labelClass,
  defaultValue,
  disabled,
  placeholder,
}: ICustomSearchDropdown) => {
  return (
    <div className={`form-group ${styles.customSelect}`}>
      {isShowLabel && (
        <label className={labelClass}>
          {iconType ? <i className={iconType} /> : ""}
          {label}
        </label>
      )}

      <AsyncSelect
        placeholder={placeholder}
        defaultValue={defaultValue}
        isClearable
        isSearchable={isSearchable}
        loadOptions={loadOptions}
        defaultOptions={defaultOptions}
        onChange={onChange}
        ref={register}
        name={name}
        isMulti={isMulti}
        isDisabled={disabled}
      />
    </div>
  );
};

export default CustomSearchDropDown;
